module.exports = __webpack_public_path__ + "img/hakuna_xmas_bg04.b98ae517.jpg";